import { TransactionTypeView, TransactionStatusView } from './enum'

import Exchange from './images/exchange.svg'
import Interest from './images/interest.svg'
import Loan from './images/loan.svg'
import Redemption from './images/redemption.svg'
import Repayment from './images/repayment.svg'
import TopUp from './images/top-up.svg'
import Withdrawal from './images/withdrawal.svg'
import InterestPercent from './images/interest_percent.svg'
import MonthlyInterest from './images/monthly_interest.svg'

export const UTCFormatDate = (isoString) => {
  if (isoString) {
    const date = new Date(isoString)
    const year = date.getUTCFullYear()
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
    const day = date.getUTCDate().toString().padStart(2, '0')
    const hour = date.getUTCHours().toString().padStart(2, '0')
    const minute = date.getUTCMinutes().toString().padStart(2, '0')

    return `${year}-${month}-${day} ${hour}:${minute} UTC`
  }

  return ''
}

export const formatDate = (isoString) => {
  if (isoString) {
    const date = new Date(isoString)

    const usaDateFormatter = new Intl.DateTimeFormat('en', {
      hour12: true,
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })

    return usaDateFormatter.format(date)
  }
  return null
}

export const formatDateForMobile = (isoString: string) => {
  const date = new Date(isoString)
  let hours = date.getHours()
  let minutes = date.getMinutes()
  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours || 12
  minutes = minutes < 10 ? Number('0' + minutes) : minutes
  const timeString = hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ' ' + ampm
  return timeString
}

export const formatHash = (hash) => {
  return hash.substring(0, 6) + '...' + hash.substring(hash.length - 6, hash.length)
}

export const getStatusColor = (status: TransactionStatusView) => {
  switch (status) {
    case TransactionStatusView.SUCCESS:
      return 'green'
    case TransactionStatusView.PROCESSING:
    case TransactionStatusView.CONFIRMING:
      return 'orange'
    case TransactionStatusView.PENDING:
      return 'gray'
    default:
      return 'black'
  }
}

export const getTypeText = (type: TransactionTypeView) => {
  switch (type) {
    case TransactionTypeView.LOAN_EVENT:
    case TransactionTypeView.MONTHLY_INTEREST:
    case TransactionTypeView.HOURLY_INTEREST:
      return 'Interest'
    case TransactionTypeView.TOP_UP:
      return 'top_up'
    default:
      return type
  }
}

export const getImage = (type: TransactionTypeView) => {
  switch (type) {
    case TransactionTypeView.EXCHANGE:
      return Exchange
    case TransactionTypeView.INTEREST:
      return Interest
    case TransactionTypeView.LOAN:
      return Loan
    case TransactionTypeView.REDEMPTION:
    case TransactionTypeView.COLLATERAL:
      return Redemption
    case TransactionTypeView.REPAYMENT:
      return Repayment
    case TransactionTypeView.DEPOSIT:
    case TransactionTypeView.INCREASE:
    case TransactionTypeView.TOP_UP:
      return TopUp
    case TransactionTypeView.LOAN_EVENT:
      return InterestPercent
    case TransactionTypeView.WITHDRAWAL:
      return Withdrawal
    case TransactionTypeView.MONTHLY_INTEREST:
    case TransactionTypeView.HOURLY_INTEREST:
      return MonthlyInterest
    default:
      return ''
  }
}
